import { Component, OnInit } from '@angular/core';
import { OrderService } from '../../../services/order.service';
import { Router } from '@angular/router';
import { PackageDetailsService } from '../../../shared/services/package-details.service';

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.scss']
})
export class OrderComponent implements OnInit {

  title = "You are ordering Likes";
  sub_title1 = "Use the form below to complete your order.";
  sub_title2 = "It's Easy As 1-2-3.";


  constructor(private _orderSer: OrderService,
    private _packSer: PackageDetailsService,
    private router: Router) { }

  ngOnInit() {

    if (!this._orderSer.order || !this._packSer.package) {
      this.router.navigate(['buy-likes']);
      return;
    }
    else {
      this.title = `You are ordering: ${this._packSer.package.amount} Likes`;
    }
  }

}
